import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import InfoIcon from '@/shared-components/icons/components/public/InfoIcon';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/ProfileUsername.css';

export default function ProfileUsername({ userType, userFlags, readOnly, error, value, onChange }) {
  const [openUsernameLockedModal, setOpenUsernameLockedModal] = useState(false);
  const isUsernameLocked = (userType !== "gallery" && !userFlags.suarteroad_completed);
  const navigate = useNavigate();
  const t = useTranslations('common.user_settings.edit_profile');

  return (
    <>
      <div className={`profile-username__container ${isUsernameLocked ? "locked" : ""}`}>
        <PublicFormInput 
          element="user_username"
          placeholder={t('username.placeholder')}
          readOnly={readOnly || isUsernameLocked} 
          error={error} 
          value={value}
          onChange={onChange}
        />

        <InfoIcon className="profile-username__username-locked-icon" onClick={()=>setOpenUsernameLockedModal(true)}/>
      </div>

      <GenericPopup
        open={openUsernameLockedModal}
        className="generic-popup_content remove-scrollbar profile-username__locked-popup"
        darkerBlur
      >
        <div className="generic-popup__header">
          <Text className="generic-popup__header-text-theme">
            {t('username.locked_modal.title')}
          </Text>
          <XIcon className="generic-popup__close" onClick={() => setOpenUsernameLockedModal(false)} />
        </div>
        <Text className="profile-username__locked-text" paragraph justify>
          {t('username.locked_modal.description')}
        </Text>

        <ContinueButton className="profile-username__suarteroad-button font-size-medium" onClick={()=>navigate("/profile/suarte-road", { from: true })}>
          {t('username.locked_modal.cta')}
        </ContinueButton>
      </GenericPopup>
    </>
  );
}
